import { Component, Input, OnInit } from '@angular/core';
import { WebsiteIdentity, WebsiteModel } from 'src/app/components/user-dashboard/portal/portal.model';
import { MediaLibraryFileModel } from 'src/app/models/sales-funnel';

@Component({
  selector: 'app-google-result-view',
  templateUrl: './google-result-view.component.html',
  styleUrls: ['./google-result-view.component.css']
})
export class GoogleResultViewComponent implements OnInit {
  @Input() favicon: MediaLibraryFileModel;
  @Input() website:
    | { siteUrl?: string; identity: Partial<WebsiteIdentity> }
    | Partial<WebsiteModel>;
  constructor() { }

  ngOnInit() {
  }

}
